<template>
  <div class="content">
    <div class="content__title content__title--party">
      <div class="table-limiter">
        <div class="table-limiter__text">Количество записей на странице:</div>
        <div class="table-limiter__select">
          <dropdown
            class="my-dropdown-toggle"
            :options="limitOptions"
            :selected="limitSelected"
            :closeOnOutsideClick="true"
            @updateOption="updateLimiter"
          />
        </div>
      </div>
      <div class="table-limiter">
        <div class="table-limiter__text">
          Показаны записи <span>{{ returnEnd() > 0 ? returnStart() : 0 }} - {{ returnEnd() }}</span> из <span>{{ pagination.count }}</span>
        </div>
      </div>
    </div>

    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      ref="bulkMovingTable"
      class="table-default"
    >
      <!-- ID -->
      <div slot="id" slot-scope="props">{{ props.row.id }}</div>

      <!-- Из рег. орг. -->
      <div slot="region_old_name" slot-scope="props">{{ props.row.region_old_name }}</div>

      <!-- В рег. орг. -->
      <div slot="region_name" slot-scope="props">{{ props.row.region_name }}</div>

      <!-- Кол-во -->
      <div slot="count" slot-scope="props">{{ props.row.count }}</div>

      <!-- Статус -->
      <div slot="status" slot-scope="props">
        <span :class="`status status--${props.row.status}`">
          {{ statusLabels[props.row.status] || props.row.status }}
        </span>
      </div>

      <!-- Дата -->
      <div slot="created_at" slot-scope="props">{{ formatDate(props.row.created_at) }}</div>

      <!-- Действия -->
      <div slot="actions" slot-scope="props">
        <button
          @click="toggleDetail(props.row.id)"
          class="table-default__button"
        >
          {{ expandedId === props.row.id ? 'Скрыть' : 'Подробнее' }}
        </button>
      </div>

      <!-- Скан-копия (внутри деталей, но можно вынести) -->
    </v-client-table>


<div v-if="expandedItem" class="table-detail-expanded">
  <div class="detail">
    <div class="detail__row">
      <span class="detail__label">Скан-копия:</span>
      <span class="detail__value">
        <a
          v-if="expandedItem.file"
          :href="expandedItem.file"
          target="_blank"
          class="link"
          @click.prevent="onDownloadFile(expandedItem.file, `заявка_${expandedItem.id}`)"
        >Скачать</a>
        <span v-else>—</span>
      </span>
    </div>
    <div v-if="expandedItem.created_name" class="detail__row">
      <span class="detail__label">Создал:</span>
      <span class="detail__value">{{ expandedItem.created_name }}</span>
    </div>
    <div v-if="expandedItem.status === 'review'" class="detail__actions">
      <button
        @click="acceptBulk(expandedItem.id)"
        :disabled="actionLoading[expandedItem.id]"
        class="button button--small button--success"
      >
        <span v-if="!actionLoading[expandedItem.id]">Принять</span>
        <span v-else class="preload">Принять</span>
      </button>
      <button
        @click="rejectBulk(expandedItem.id)"
        :disabled="actionLoading[expandedItem.id]"
        class="button button--small button--abort"
        style="margin-left: 10px;"
      >
        <span v-if="!actionLoading[expandedItem.id]">Отклонить</span>
        <span v-else class="preload">Отклонить</span>
      </button>
    </div>
  </div>
</div>

    <paginate
      v-if="pagination.pages > 1"
      v-model="pagination.page"
      :page-count="pagination.pages"
      :clickHandler="clickPaginationCallback"
      :prev-text="'<'"
      :next-text="'>'"
      :container-class="'pagination'"
      :page-class="'pagination__item'"
      :page-link-class="'pagination__link'"
      :prev-class="'pagination__prev'"
      :next-class="'pagination__next'"
      :next-link-class="'pagination__link-next'"
      :prev-link-class="'pagination__link-prev'"
    />
  </div>
</template>

<script>
import dropdown from 'vue-dropdowns'

export default {
  name: 'BulkMovingList',
  components: { dropdown },
  data() {
    return {
      expandedId: null,
      actionLoading: {},
      table: {
        items: [],
        columns: ['id', 'region_old_name', 'region_name', 'count', 'status', 'created_at', 'actions'],
        options: {
          headings: {
            id: 'ID',
            region_old_name: 'Из рег. орг.',
            region_name: 'В рег. орг.',
            count: 'Кол-во',
            status: 'Статус',
            created_at: 'Дата',
            actions: 'Действия',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            filter: '',
            filterPlaceholder: 'Поиск по таблице',
            noResults: 'Нет заявок на массовое перемещение',
            count: '',
            limit: 'Количество записей на странице:',
            page: 'Страница:'
          },
          rowClassCallback: row => `table-default__row table-default__row--${row.status}`,
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 0,
      },
      limitSelected: { name: 20 },
      limitOptions: [
        { name: 20 },
        { name: 40 },
        { name: 60 },
        { name: 80 },
        { name: 100 },
      ],
      statusLabels: {
        review: 'На рассмотрении',
        accepted: 'Принята',
        rejected: 'Отклонена'
      }
    }
  },
  mounted() {
    this.fetchItems(1, this.limitSelected.name)
  },
  methods: {
    fetchItems(page = 1, limit) {
      this.$store.dispatch('journal/GET_BULK_MOVING_LIST', { page, limit })
        .then(response => {
          this.table.items = response.data.results || []
          this.pagination.pages = response.data.pages || 1
          this.pagination.count = response.data.count || 0
        })
        .catch(() => {
          this.$notify({ type: 'error', title: 'Ошибка!', text: 'Не удалось загрузить список' })
        })
    },
    updateLimiter(data) {
      this.limitSelected.name = data.name
      this.fetchItems(this.pagination.page, this.limitSelected.name)
    },
    clickPaginationCallback(page) {
      this.pagination.page = page
      this.fetchItems(page, this.limitSelected.name)
    },
    toggleDetail(id) {
      this.expandedId = this.expandedId === id ? null : id
    },
    acceptBulk(id) {
      this.actionLoading[id] = true
      this.$store.dispatch('journal/ACCEPT_BULK_MOVING', id)
        .then(() => {
          this.actionLoading[id] = false
          this.$notify({ type: 'success', title: 'Успех!', text: 'Заявка принята' })
          this.fetchItems(this.pagination.page, this.limitSelected.name)
        })
        .catch(error => {
          this.actionLoading[id] = false
          const msg = error.response?.data?.message || 'Не удалось принять заявку'
          this.$notify({ type: 'error', title: 'Ошибка!', text: msg })
        })
    },
    rejectBulk(id) {
      this.$notify({ type: 'warn', title: 'Внимание!', text: 'Отклонение заявок временно недоступно' })
    },
    formatDate(dateString) {
      if (!dateString) return '—'
      return new Date(dateString).toLocaleDateString('ru-RU')
    },
    returnStart() {
      return (this.pagination.page - 1) * this.limitSelected.name + 1
    },
    returnEnd() {
      const end = this.pagination.page * this.limitSelected.name
      return end > this.pagination.count ? this.pagination.count : end
    },
    async onDownloadFile(url, name) {
      try {
        const response = await fetch(url)
        const blob = await response.blob()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${name}.pdf`
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (e) {
        this.$notify({ type: 'error', title: 'Ошибка!', text: 'Не удалось скачать файл' })
      }
    }
  }
}
</script>

<style scoped>
.table-detail-expanded {
  background-color: #f8fdff;
  padding: 16px 20px;
  margin-bottom: 10px;
  border-left: 4px solid #2b93e7;
}
.detail {
  max-width: 800px;
}
.detail__row {
  display: flex;
  margin-bottom: 8px;
}
.detail__label {
  width: 150px;
  font-weight: 600;
  color: #333;
}
.detail__value {
  flex: 1;
  color: #555;
}
.detail__actions {
  margin-top: 12px;
  display: flex;
  align-items: center;
}
.status {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}
.status--review {
  background-color: #e0f0ff;
  color: #2b93e7;
}
.status--accepted {
  background-color: #e6f4ea;
  color: #38bf4e;
}
.status--rejected {
  background-color: #fce8eb;
  color: #ea5467;
}
</style>